




















import { Component, Vue, Watch } from 'vue-property-decorator'
import { RouteRecord } from 'vue-router'
import { compile } from 'path-to-regexp'

@Component
export default class Breadcrumb extends Vue {
  levelList: RouteRecord[] = []

  showText(item: RouteRecord, index: number) {
    return item.redirect === 'noredirect' ||
      index === this.levelList.length - 1 ||
      item.path === this.$route.path ||
      `${item.path}/` === this.$route.path
  }

  get enabledLevelList(): RouteRecord[] {
    return this.levelList.filter(level => !!level.meta.title)
  }

  created(): void {
    this.getBreadcrumb()
  }

  @Watch('$route')
  onRouteChange(): void {
    this.getBreadcrumb()
  }

  getBreadcrumb(): void {
    if (this.$route.name && this.$route.name.includes('error')) {
      this.levelList = [this.$route.matched[0]]
      return
    }

    let { params } = this.$route

    this.levelList = this.$route.matched.filter(item => {
      if (item.name) {
        let toPath = compile(item.path)

        item.path = toPath(params)

        return true
      }
    })
  }
}
